<template>
  <v-dialog
    v-model="modalState"
    transition="dialog-bottom-transition"
    persistent
    width="1000"
  >
    <div class="bg-white poppins">
      <div class="modal-header py-4 align-center">
        <h4 class="mb-0 font-weight-bolder">Add Comment</h4>
        <div
          class="btn btn-sm btn-icon btn-active-light-info"
          @click="toggleModal"
        >
          <span class="svg-icon">
            <v-icon size="22">mdi-close</v-icon>
          </span>
        </div>
      </div>
      <div class="modal-body d-flex flex-column scroll-y mx-5 mt-4">
        <v-row class="pa-0">
          <v-col cols="12">
            <v-textarea
              label="Comment"
              v-model="formData.comment"
              dense
              outlined
              :error-messages="commentErrors"
              @input="$v.formData.comment.$touch()"
              @blur="$v.formData.comment.$touch()"
            />
          </v-col>
        </v-row>
        <!--begin::Actions-->
        <div class="my-4 d-flex flex-grow-1 align-end justify-center">
          <button
            @click.prevent="clearFields"
            type="reset"
            class="btn btn-light mr-3 px-5 py-3 ls1"
          >
            Clear
          </button>
          <button
            @click.prevent="submitStatusUpdate"
            type="submit"
            class="btn btn-info px-5 py-3 ls1"
          >
            Submit
          </button>
        </div>
        <!--end::Actions-->
      </div>
    </div>
  </v-dialog>
</template>

<script>
import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import Swal from "sweetalert2";
import { required } from "vuelidate/lib/validators";
import validationMixin from "@/own/mixins/validationMixin";

export default {
  name: "AddComment",
  components: {},
  props: {
    refresher: { required: true, type: Function },
  },
  mixins: [validationMixin],
  validations() {
    return {
      formData: {
        comment: { required },
      },
    };
  },
  data: () => ({
    modalState: false,
    formData: {
      return_id: null,
      comment: null,
    },
  }),
  computed: {
    commentErrors() {
      return this.handleFormValidation("comment", this);
    },
  },
  methods: {
    toggleModal(data) {
      if (!this.modalState) {
        this.formData.return_id = data?.id;
      } else this.clearFields();
      this.modalState = !this.modalState;
    },

    submitStatusUpdate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.$store.commit(SET_PAGE_LOADING, true);
      ApiService.post(
        `/shipping/returns_management/add_exception_comment
`,
        {
          ...this.formData,
        }
      )
        .then(() => {
          Swal.fire({
            title: "Updated",
            text: "Comment is added",
            icon: "success",
            showConfirmButton: false,
            timer: 2500,
          });
          this.refresher();
          this.toggleModal();
        })
        .finally(() => {
          this.$store.commit(SET_PAGE_LOADING, false);
        });
    },
    clearFields() {
      this.$v.$reset();
      this.formData = {
        return_id: null,
        comment: null,
      };
    },
  },
};
</script>
